/**
 * Created by ok on 8/11/17.
 */
import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import {
    sliderColorChanged, singleColorChanged
} from '../../actions/recoloring';

import { resetColorSlider } from '../../actions/uiActions';
import { getShouldSliderReset } from '../../reducers/ui.recoloring';

class ColorSlider extends React.Component {
    state = {
        hue: 0,
        saturation: 0.5,
        lightness: 0.5,
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.reset) {
            this.setState(Object.assign({}, {
                hue: 0,
                saturation: 0.5,
                lightness: 0.5,
            }));
            this.props.toggleReset(false);
        }
    }
    StyledSlider = styled.input`
        height: 6px;
        cursor: pointer;
        background-color: #ccc;
        border: 0;
        border-radius: 99999px;
        appearance: none;
        width: 100%;
        outline: none;
        padding: 0;

        &::-webkit-slider-thumb {
          appearance: none;
          width: 1em;
          height: 1.62em;
          border: 0;
          border-radius: 99999px;
          background: #C06;
        }
        &:focus {
          &::-webkit-slider-thumb {

          }
        }
    `;
    Flex = styled.div`
        display: flex;
        flex-direction: row;
    `;
    Box = styled.div`
        width: 33%;
        padding: 0.2rem;
    `;
    debounce = debounce((fn, value, name) => {
        fn(value, name);
    }, 300);
    handleChange = event => {
        const value = event.currentTarget.value;
        const name = event.target.name;
        this.setState(Object.assign({}, this.state, { [name]: value }));
        this.props.onChange(value, name);
        this.props.onChangeComplete && this.debounce(this.props.onChangeComplete, value, name);
    };

    toPercent = value => `${value * 100}%`;

    render() {
        return (
            <this.Flex>
                <this.Box width={1/3} p={1}>
                    <FormattedMessage
                        id='SLIDER_LABEL_HUE'
                        defaultMessage='Farbton'
                    />
                    <this.StyledSlider
                        className='slider-hue'
                        onChange={this.handleChange} type='range'
                        step='1' min='0' max='360'
                        value={this.state.hue} name='hue'
                        key='hue'
                    />
                </this.Box>
                <this.Box width={1/3} p={1}>
                    <FormattedMessage
                        id='SLIDER_LABEL_SATURATION'
                        defaultMessage='Sättigung'
                    />
                    <this.StyledSlider
                        onChange={this.handleChange} type='range'
                        step='0.01' min='0' max='1'
                        value={this.state.saturation}
                        name='saturation'
                        key='saturation'
                    />
                </this.Box>
                <this.Box width={1/3} p={1}>
                    <FormattedMessage
                        id='SLIDER_LABEL_LIGHTNESS'
                        defaultMessage='Helligkeit'
                    />
                    <this.StyledSlider
                        onChange={this.handleChange} type='range'
                        step='0.01' min='0' max='1'
                        value={this.state.lightness}
                        name='lightness'
                        key='lightness'
                    />
                </this.Box>
            </this.Flex>
        );
    }
}


const mapDispatch = dispatch => (
    {
        onChange: (color, type) => dispatch(sliderColorChanged(
                color,
                type,
            )),
        onChangeComplete: color => dispatch(singleColorChanged(color)),
        toggleReset: bool => dispatch(resetColorSlider(bool)),
    }
    );

const mapState = state => ({
    reset: getShouldSliderReset(state),
});

export default connect(mapState, mapDispatch)(ColorSlider);



// WEBPACK FOOTER //
// ./src/components/recoloring/Slider.js